 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLEPAGE from '@/components/titlepage'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_000 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_000'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_001 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_001'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_002 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_002'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_003 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_003'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_004 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_004'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_005 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_005'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_006 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_006'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_007 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_007'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_008 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_008'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_009 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_009'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_010 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_010'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_011 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_011'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_012 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_012'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_013 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_013'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_014 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_014'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_015 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_015'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_016 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_016'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_017 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_017'
 import TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_018 from '@/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_018'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_000",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_000",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_000
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_001",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_001",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_001
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_002",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_002",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_002
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_003",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_003",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_003
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_004",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_004",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_004
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_005",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_005",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_005
 		},
 		{
 			"path" : "/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_006",
 			"name" : "tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_006",
 			"component" : TMP_403FA671F87995D2E5AEDDA9ECDDAD25_61BGYMCHFIXEDFCTIDIEDSTYLEHACKEDXFIXED_SPLIT_006
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js